// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Issue_bottomLine__1cK9L","Issue":"Issue_Issue__2SXg7","description":"Issue_description__1GykS","Section":"Issue_Section__3HQNu","cover":"Issue_cover__Huv0p"};